module.exports = __webpack_public_path__ + "static/media/23.2cb79871.jpg";